import axios from "axios";

export interface LinkableTransactionMaterial {
  code: string;
  name: string;
  quantity: number;
}

export interface LinkableTransaction {
  pickupTransactionNumber: string;
  shipmentTransactionNumber: string | null;
  completedDate: string;
  haulerName: string | null;
  materials: LinkableTransactionMaterial[];
}

export interface LinkableTransactionsResponse {
  limit: number;
  transactions: LinkableTransaction[];
}

export const getLinkableTransactions = (
  requestNumber: string,
  search?: string
): Promise<LinkableTransactionsResponse> =>
  axios
    .get<LinkableTransactionsResponse>(
      `pickupRequests/${requestNumber}/linkableTransactions`,
      { params: search ? { search } : undefined }
    )
    .then((res) => res.data);

export default getLinkableTransactions;
